import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles({
  titleWin: {
    width: '60px',
    textAlign: 'center',
    fontSize: '13px',
    fontWeight: 600,
    marginLeft: '7px',
  },
  titleLoss: {
    width: '60px',
    textAlign: 'center',
    fontSize: '13px',
    fontWeight: 600,
    marginLeft: '7px',
  },
  titleDraw: {
    width: '60px',
    textAlign: 'center',
    fontSize: '13px',
    fontWeight: 600,
    color: '#ffffffcc',
    marginLeft: '7px',
  },
  titlePercent: {
    width: '60px',
    textAlign: 'center',
    fontSize: '13px',
    fontWeight: 600,
    color: '#ffffffcc',
    marginLeft: '7px',
  },
  boxTitles: {
    background: 'transparent !important',
    fontSize: '14px',
    color: '#ffffffdd',
    fontWeight: 500,
  },
});
